import { drilldownData, ModuleFields } from "~/Utils/drilldownData";

const mapFields = (data: ModuleFields[]) =>{
 return(
  data.map(({ fieldName, placeholder, name, formType, validation, className,usedFileType }) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    usedFileType: usedFileType
  }))
 )
}

export const fields: any = {
  subsidiariesPageHeading: mapFields(
    drilldownData["subsidiariesPageHeading"]
  ),
};
